var v1='<ul class=lumx-list ng-class=lx.getClasses() tabindex="{{ lx.isClickable ? 0 : -1 }}" ng-transclude></ul>';
angular.module('lumx.list').run(['$templateCache', function ($templateCache) {$templateCache.put('list.html', v1);}]);
module.exports=v1